import React from 'react';
import { IconX, IconChevronUp, IconChevronDown } from '@tabler/icons-react';
import EmployeeSearchField from '../../../components/common/EmployeeSearchField';

// value is an ordered array of {id, name, organization}; reviewer 1 acts first.
export default function ReviewerChainField({
  label = 'Reviewers',
  required,
  orgId,
  value = [],
  onChange,
  excludeIds = [],
  error,
}) {
  const selectedIds = value.map((r) => String(r.id));

  const handleAdd = (emp) => {
    if (selectedIds.includes(String(emp.id))) return;
    onChange([...value, emp]);
  };

  const handleRemove = (id) => {
    onChange(value.filter((r) => String(r.id) !== String(id)));
  };

  const handleMove = (index, direction) => {
    const target = index + direction;
    if (target < 0 || target >= value.length) return;
    const next = [...value];
    [next[index], next[target]] = [next[target], next[index]];
    onChange(next);
  };

  return (
    <div>
      <label className="block text-sm font-medium mb-5">
        {label} {required && <span className="text-danger">*</span>}
      </label>

      {value.length > 0 && (
        <div className="flex flex-col gap-6 mb-8">
          {value.map((reviewer, index) => (
            <div
              key={reviewer.id}
              className="flex items-center gap-8 bg-bg-light border border-border rounded-[4px] px-10 py-[6px]"
            >
              <span className="text-xs font-medium text-text-secondary w-16 shrink-0">
                {index + 1}.
              </span>
              <div className="flex-1 min-w-0">
                <p className="text-sm font-medium truncate">{reviewer.name}</p>
                {reviewer.organization && (
                  <p className="text-xs text-text-secondary truncate">{reviewer.organization}</p>
                )}
              </div>
              <div className="flex items-center gap-3 shrink-0">
                <button
                  type="button"
                  onClick={() => handleMove(index, -1)}
                  disabled={index === 0}
                  className="text-text-secondary hover:text-text-main disabled:opacity-30 disabled:cursor-not-allowed"
                  title="Move up"
                >
                  <IconChevronUp size={15} />
                </button>
                <button
                  type="button"
                  onClick={() => handleMove(index, 1)}
                  disabled={index === value.length - 1}
                  className="text-text-secondary hover:text-text-main disabled:opacity-30 disabled:cursor-not-allowed"
                  title="Move down"
                >
                  <IconChevronDown size={15} />
                </button>
                <button
                  type="button"
                  onClick={() => handleRemove(reviewer.id)}
                  className="text-text-secondary hover:text-danger"
                  title="Remove"
                >
                  <IconX size={15} />
                </button>
              </div>
            </div>
          ))}
        </div>
      )}

      <EmployeeSearchField
        orgId={orgId}
        value={null}
        onSelect={handleAdd}
        onClear={() => {}}
        excludeIds={[...selectedIds, ...excludeIds]}
        placeholder="Search to add a reviewer..."
        error={error}
      />
      <p className="text-xs text-text-secondary mt-5">
        Review order follows the list above — reviewer 1 acts first.
      </p>
    </div>
  );
}
